import React, { useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useOrderRedux, usePubSubEvents } from '@hooks'
import { Loader, OrderStatusList } from '@components'
import { processOrderStatus, PUB_SUB_EVENT, ROUTES } from '@common'
import { useOrderEventContext } from '@context'

export default function OrderStatusPage() {
    const { orderNumber } = useParams()
    const navigate = useNavigate()
    const { isLoading, searchedOrder, fetchOrderByNumber } = useOrderRedux()
    const { setCurrentOrderId } = useOrderEventContext()
    // listen to pubsub events
    usePubSubEvents({
        events: [PUB_SUB_EVENT.ORDER_PAYMENT_STATUS_UPDATE, PUB_SUB_EVENT.COMPLETED_DISH, PUB_SUB_EVENT.COMPLETED_ORDER],
        handlers: {
            [PUB_SUB_EVENT.COMPLETED_ORDER]: async order => {
                if (order.number === orderNumber) {
                    const res = await fetchOrderByNumber(orderNumber)

                    if (res.meta.requestStatus === 'rejected') {
                        navigate(ROUTES.Order.search, { replace: true })
                    }
                }
            },
        },
    })

    const { lineitems, totalQuantity, totalAmount } = useMemo(() => processOrderStatus(searchedOrder), [searchedOrder])

    // const timerRef = useRef(null)

    // const startTimer = () => {
    //     // Clear any existing timer first
    //     if (timerRef.current) {
    //         clearInterval(timerRef.current)
    //     }
    //     // Start a new timer
    //     timerRef.current = setInterval(() => {
    //         fetchOrderByNumber(orderNumber)
    //     }, 60 * 1000)
    // }

    // const stopTimer = () => {
    //     if (timerRef.current) {
    //         clearInterval(timerRef.current)
    //         timerRef.current = null
    //     }
    // }

    useEffect(() => {
        setCurrentOrderId(searchedOrder?.orderId)

        return () => {
            setCurrentOrderId(null)
        }
    }, [searchedOrder, setCurrentOrderId])

    useEffect(() => {
        const run = async () => {
            if (!searchedOrder || searchedOrder.number !== orderNumber) {
                const res = await fetchOrderByNumber(orderNumber)

                if (res.meta.requestStatus === 'rejected') {
                    navigate(ROUTES.Order.search, { replace: true })
                }
            }
        }

        run()

        // return () => {
        //     stopTimer()
        // }
        // eslint-disable-next-line
    }, [orderNumber, navigate])

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                fetchOrderByNumber(orderNumber)
            }
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange)
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div>
            {isLoading && <Loader />}
            <h1 className="text-center">Order Status</h1>
            <h2 className="text-center">#{orderNumber}</h2>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <i className="bx bx-refresh bx-sm me-2" onClick={() => fetchOrderByNumber(orderNumber)}></i>
                {/* <button
                    className="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
                    onClick={() => navigate(ROUTES.Order.receipt.replace(':orderNumber', orderNumber))}
                >
                    View Receipt
                    <i className="bx bx-right-arrow-alt bx-sm ms-2"></i>
                </button> */}
            </div>
            {searchedOrder && <OrderStatusList lineitems={lineitems} />}
            <div className="d-flex justify-content-between px-3 mt-5">
                <h3>Total ({totalQuantity}):</h3>
                <h3>S$ {totalAmount.toFixed(2)}</h3>
            </div>
        </div>
    )
}
